// Heliont UserInterface core bootstrap (Gateway/Web/Js/_core.js)
// Ui/Core/Services/TranslationService/TranslationService.js

(function () {
    if (!window.Heliont) {
        window.Heliont = {};
    }
    window.Heliont.Core = window.Heliont.Core || {};
    window.Heliont.Core.Services = window.Heliont.Core.Services || {};

    function TranslationService(namespace) {
        this.namespace = namespace || null;
    }

    TranslationService.prototype.setNamespace = function (namespace) {
        this.namespace = namespace;
    };

    /**
     * t(key, placeholders?)
     *
     * Lookup order:
     *   1) nested window.__HELIONT__.translations (page bootstrap)
     *   2) __TRANSLATIONS__[namespace][key]
     *   3) __TRANSLATIONS__.Global[key]
     *   4) "[key]" (debug-friendly fallback)
     *
     * Placeholders:
     *   JSON:  "hello": "Hello %name%!"
     *   Code:  t('hello', { name: 'Mario' })
     */
    TranslationService.prototype.t = function (key, placeholders) {
        try {
            var value = this.lookup(key);

            if (placeholders && typeof placeholders === 'object') {
                Object.keys(placeholders).forEach(function (phKey) {
                    var token = '%' + phKey + '%';
                    var phValue = String(placeholders[phKey]);
                    value = value.split(token).join(phValue);
                });
            }

            return value;
        } catch (e) {
            return '[' + key + ']';
        }
    };

    TranslationService.prototype.lookup = function (key) {
        var nested = window.__HELIONT__ && window.__HELIONT__.translations;
        if (nested && typeof nested === 'object') {
            var parts = String(key).split('.');
            var current = nested;
            var i;
            for (i = 0; i < parts.length; i += 1) {
                if (!current || typeof current !== 'object' || !Object.prototype.hasOwnProperty.call(current, parts[i])) {
                    current = null;
                    break;
                }
                current = current[parts[i]];
            }
            if (typeof current === 'string' && current !== '') {
                return current;
            }
        }

        var translations = window.__TRANSLATIONS__ || {};
        var ns = this.namespace;

        if (
            ns &&
            translations[ns] &&
            Object.prototype.hasOwnProperty.call(translations[ns], key) &&
            typeof translations[ns][key] === 'string' &&
            translations[ns][key] !== ''
        ) {
            return translations[ns][key];
        }

        if (
            translations.Global &&
            Object.prototype.hasOwnProperty.call(translations.Global, key) &&
            typeof translations.Global[key] === 'string' &&
            translations.Global[key] !== ''
        ) {
            return translations.Global[key];
        }

        return '[' + key + ']';
    };

    // Expose class in core services
    window.Heliont.Core.Services.TranslationService = TranslationService;
})();// Ui/Core/Services/ApiService/ApiService.js

(function () {
    if (!window.Heliont) {
        window.Heliont = {};
    }
    window.Heliont.Core = window.Heliont.Core || {};
    window.Heliont.Core.Services = window.Heliont.Core.Services || {};

    // ─────────────────────────────────────────────────────────────
    // HeliontApiError
    // ─────────────────────────────────────────────────────────────

    function HeliontApiError(message, options) {
        Error.call(this, message);
        this.name = 'HeliontApiError';
        // Error.call does not reliably assign message under prototypal inheritance.
        this.message = message != null ? String(message) : '';

        options = options || {};
        this.status = options.status != null ? options.status : null;
        this.errorCode = options.errorCode || null;
        this.errorType = options.errorType || null;
        this.nextAction = options.nextAction || null;
        this.details = options.details || null;
        this.links = options.links || null;
        this.payload = options.payload || null;
        this.url = options.url || null;
        this.requiredTrustLevel = options.requiredTrustLevel || null;
        this.request = options.request || null;
    }

    HeliontApiError.prototype = Object.create(Error.prototype);
    HeliontApiError.prototype.constructor = HeliontApiError;

    HeliontApiError.prototype.isAuthenticationRequired = function () {
        return this.status === 401 && this.errorCode === 'authentication_required';
    };

    HeliontApiError.prototype.isTrustLevelStepUpRequired = function () {
        return (
            this.status === 403 &&
            this.errorCode === 'trust_level_required' &&
            this.nextAction === 'step_up'
        );
    };

    HeliontApiError.prototype.isStepUpCancelled = function () {
        return this.status === 403 && this.errorCode === 'step_up_cancelled';
    };

    HeliontApiError.prototype.isPermissionDenied = function () {
        return this.status === 403 && this.errorCode === 'permission_denied';
    };

    function payloadFailureMessage(payload, fallback) {
        var nested = payload && payload.error;
        var nestedMessage = '';
        if (nested && typeof nested === 'object') {
            nestedMessage = String(nested.message || nested.errorText || nested.error_text || '').trim();
        } else if (typeof nested === 'string') {
            nestedMessage = nested.trim();
        }
        var top = payload && typeof payload.message === 'string' ? payload.message.trim() : '';
        if (nestedMessage !== '') {
            return nestedMessage;
        }
        if (top !== '') {
            return top;
        }
        return fallback;
    }

    // ─────────────────────────────────────────────────────────────
    // Step-up interrupt (framework in-app IAM overlay)
    // ─────────────────────────────────────────────────────────────

    function loadStylesheetOnce(href) {
        return new Promise(function (resolve, reject) {
            var normalized = String(href || '').trim();
            if (normalized === '') {
                resolve();
                return;
            }

            if (document.querySelector('link[data-heliont-stepup-asset="' + normalized + '"]')) {
                resolve();
                return;
            }

            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = normalized;
            link.setAttribute('data-heliont-stepup-asset', normalized);
            link.onload = function () { resolve(); };
            link.onerror = function () {
                reject(new Error('Failed to load stylesheet: ' + normalized));
            };
            document.head.appendChild(link);
        });
    }

    function loadScriptOnce(src) {
        return new Promise(function (resolve, reject) {
            var normalized = String(src || '').trim();
            if (normalized === '') {
                resolve();
                return;
            }

            var existing = document.querySelector('script[data-heliont-stepup-asset="' + normalized + '"]');
            if (existing) {
                if (existing.getAttribute('data-heliont-loaded') === '1') {
                    resolve();
                    return;
                }
                existing.addEventListener('load', function () { resolve(); }, { once: true });
                existing.addEventListener('error', function () {
                    reject(new Error('Failed to load script: ' + normalized));
                }, { once: true });
                return;
            }

            var script = document.createElement('script');
            script.src = normalized;
            script.defer = true;
            script.setAttribute('data-heliont-stepup-asset', normalized);
            script.onload = function () {
                script.setAttribute('data-heliont-loaded', '1');
                resolve();
            };
            script.onerror = function () {
                reject(new Error('Failed to load script: ' + normalized));
            };
            document.body.appendChild(script);
        });
    }

    function StepUpInterrupt(apiService) {
        this.apiService = apiService;
        this.isActive = false;
        this.interruptTurn = Promise.resolve();
        this.pendingResolve = null;
        this.pendingReject = null;
        this.lastFormUrl = null;
        this.suspendedHostOverlay = false;
        this.cancelledByUser = false;
    }

    StepUpInterrupt.prototype.buildFormUrl = function (error) {
        var formUrl = error && error.links && error.links.step_up_form;
        if (formUrl) {
            return formUrl;
        }

        var required = (error && error.requiredTrustLevel) || 'challenged';
        return '/api/iam/obtain-step-up-form?required=' + encodeURIComponent(required);
    };

    StepUpInterrupt.prototype.loadAssets = function (assets) {
        assets = assets || {};
        var stylesheets = Array.isArray(assets.stylesheets) ? assets.stylesheets : [];
        var scripts = Array.isArray(assets.scripts) ? assets.scripts : [];
        var chain = Promise.resolve();

        stylesheets.forEach(function (href) {
            chain = chain.then(function () {
                return loadStylesheetOnce(href);
            });
        });

        scripts.forEach(function (src) {
            chain = chain.then(function () {
                return loadScriptOnce(src);
            });
        });

        return chain;
    };

    StepUpInterrupt.prototype.mountOverlayHtml = function (overlayHtml) {
        var overlay = window.Heliont?.plugins?.iamOverlay;
        if (overlay && typeof overlay.removeStepUpDom === 'function') {
            overlay.removeStepUpDom();
        } else {
            document.getElementById('heliont-stepup-interrupt-root')?.remove();
        }

        if (overlay && typeof overlay.hasActiveHost === 'function' && overlay.hasActiveHost()) {
            if (typeof overlay.suspend === 'function') {
                overlay.suspend();
            }
            this.suspendedHostOverlay = true;
        } else if (overlay && typeof overlay.unmount === 'function') {
            overlay.unmount();
            this.suspendedHostOverlay = false;
        }

        var wrapper = document.createElement('div');
        wrapper.id = 'heliont-stepup-interrupt-root';
        wrapper.innerHTML = overlayHtml;
        document.body.appendChild(wrapper);

        if (window.Heliont?.plugins?.iamOverlay?.bootstrap) {
            window.Heliont.plugins.iamOverlay.bootstrap();
        }
    };

    StepUpInterrupt.prototype.closeDom = function () {
        var overlay = window.Heliont?.plugins?.iamOverlay;
        if (overlay && typeof overlay.removeStepUpDom === 'function') {
            overlay.removeStepUpDom();
        } else {
            document.getElementById('heliont-stepup-interrupt-root')?.remove();
            if (overlay && typeof overlay.unmount === 'function') {
                overlay.unmount();
            }
        }

        if (overlay && typeof overlay.resume === 'function') {
            overlay.resume();
        }

        this.suspendedHostOverlay = false;
    };

    StepUpInterrupt.prototype.fetchFormPayload = function (formUrl) {
        return fetch(formUrl, {
            method: 'GET',
            credentials: 'include',
            headers: { Accept: 'application/json' },
        }).then(function (response) {
            return response.text().then(function (text) {
                var payload = null;
                if (text !== '') {
                    try {
                        payload = JSON.parse(text);
                    } catch (parseError) {
                        // ignore
                    }
                }

                if (!response.ok) {
                    throw new HeliontApiError(
                        (payload && payload.message) || 'Unable to load security challenge.',
                        {
                            status: response.status,
                            errorCode: (payload && (payload.errorCode || payload.error)) || null,
                            payload: payload,
                            url: formUrl,
                        }
                    );
                }

                var data = payload && payload.data && typeof payload.data === 'object'
                    ? payload.data
                    : payload;

                if (!data || typeof data !== 'object') {
                    throw new HeliontApiError('Invalid step-up form response.', {
                        status: response.status,
                        url: formUrl,
                    });
                }

                return data;
            });
        });
    };

    StepUpInterrupt.prototype.presentPayload = function (payload) {
        var self = this;

        if (payload.stepUpComplete === true) {
            return Promise.resolve();
        }

        var overlayHtml = typeof payload.overlayHtml === 'string' ? payload.overlayHtml.trim() : '';
        if (overlayHtml === '') {
            return Promise.reject(new HeliontApiError('Security challenge is unavailable.', {
                status: 403,
                errorCode: 'trust_level_required',
                nextAction: 'step_up',
            }));
        }

        return self.loadAssets(payload.assets).then(function () {
            self.isActive = true;
            self.mountOverlayHtml(overlayHtml);
        });
    };

    StepUpInterrupt.prototype.open = function (error) {
        var self = this;
        var formUrl = self.buildFormUrl(error);
        self.lastFormUrl = formUrl;

        var run = self.interruptTurn.then(function () {
            return new Promise(function (resolve, reject) {
                self.pendingResolve = resolve;
                self.pendingReject = reject;

                self.fetchFormPayload(formUrl)
                    .then(function (payload) {
                        if (payload.stepUpComplete === true) {
                            self.complete(true);
                            return;
                        }
                        return self.presentPayload(payload);
                    })
                    .catch(function (err) {
                        self.complete(false);
                        reject(err);
                    });
            });
        });

        self.interruptTurn = run.catch(function () { });
        return run;
    };

    StepUpInterrupt.prototype.refresh = function () {
        var self = this;
        var formUrl = self.lastFormUrl || '/api/iam/obtain-step-up-form';

        return self.fetchFormPayload(formUrl).then(function (payload) {
            if (payload.stepUpComplete === true) {
                self.complete(true);
                return;
            }
            return self.presentPayload(payload);
        });
    };

    StepUpInterrupt.prototype.complete = function (success) {
        var resolve = this.pendingResolve;
        var reject = this.pendingReject;
        this.pendingResolve = null;
        this.pendingReject = null;
        this.isActive = false;
        this.closeDom();

        if (success === false) {
            var cancelledByUser = this.cancelledByUser === true;
            this.cancelledByUser = false;
            if (typeof reject === 'function') {
                reject(new HeliontApiError(
                    cancelledByUser
                        ? 'Security challenge was cancelled.'
                        : 'Security challenge was not completed.',
                    {
                        status: 403,
                        errorCode: cancelledByUser ? 'step_up_cancelled' : 'trust_level_required',
                        nextAction: cancelledByUser ? null : 'step_up',
                    }
                ));
            }
            return;
        }

        if (typeof resolve === 'function') {
            resolve();
        }
    };

    StepUpInterrupt.prototype.close = function (success) {
        this.complete(success !== false);
    };

    // ─────────────────────────────────────────────────────────────
    // ApiService (core)
    // ─────────────────────────────────────────────────────────────

    function currentStepUpReturnTo() {
        return window.location.pathname + window.location.search + window.location.hash;
    }

    function ApiService() {
        this.useLegacyStepUpNavigation = false;
        this.handlers = {
            onTrustLevelStepUpRequired: defaultStepUpHandler.bind(this),
            onPermissionDenied: defaultPermissionHandler,
            onError: defaultErrorHandler
        };
    }

    ApiService.prototype.setHandlers = function (handlers) {
        handlers = handlers || {};
        if (typeof handlers.onTrustLevelStepUpRequired === 'function') {
            this.useLegacyStepUpNavigation = true;
        }
        this.handlers = Object.assign({}, this.handlers, handlers);
    };

    ApiService.prototype.request = function (endpoint, options) {
        var self = this;
        options = options || {};

        return this.executeRequest(endpoint, options).catch(function (err) {
            if (!(err instanceof HeliontApiError) || !err.isTrustLevelStepUpRequired()) {
                throw err;
            }

            if (options._heliontSkipStepUpRetry === true) {
                throw err;
            }

            return self.resolveTrustLevelStepUp(err).then(function () {
                return self.executeRequest(endpoint, options);
            });
        });
    };

    ApiService.prototype.executeRequest = function (endpoint, options) {
        options = options || {};

        var url = this.buildUrl(endpoint, options.query);

        var headers = Object.assign(
            { Accept: 'application/json' },
            options.headers || {}
        );

        var method = (options.method || 'GET').toUpperCase();
        var originalBody = options.body;
        var body = originalBody;

        if (body != null && method !== 'GET' && method !== 'HEAD') {
            var isPlainObject =
                typeof body === 'object' &&
                !(body instanceof FormData) &&
                !(body instanceof Blob) &&
                !(body instanceof ArrayBuffer);

            if (typeof body === 'string') {
                if (!headers['Content-Type']) {
                    headers['Content-Type'] = 'application/json; charset=utf-8';
                }
            } else if (isPlainObject) {
                if (!headers['Content-Type']) {
                    headers['Content-Type'] = 'application/json; charset=utf-8';
                }
                body = JSON.stringify(body);
            }
        }

        headers['X-Correlation-ID'] = this.generateCorrelationId();

        var fetchOptions = {
            method: method,
            headers: headers,
            body: body,
            credentials: options.credentials || 'include'
        };

        var self = this;
        var replayableRequest = this.buildReplayableRequest(endpoint, method, originalBody);

        if (options.responseType === 'blob') {
            headers.Accept = (options.headers && options.headers.Accept)
                ? options.headers.Accept
                : 'application/octet-stream, image/*, */*';
            fetchOptions.headers = headers;
        }

        return fetch(url, fetchOptions)
            .then(function (response) {
                if (options.responseType === 'blob') {
                    return response.blob().then(function (blob) {
                        if (response.ok) {
                            return blob;
                        }
                        var error = new HeliontApiError(
                            'HTTP ' + response.status + ' for ' + url,
                            {
                                status: response.status,
                                url: url,
                                request: replayableRequest,
                            }
                        );
                        if (error.isPermissionDenied()) {
                            self.handlers.onPermissionDenied(error);
                        } else if (!error.isTrustLevelStepUpRequired()) {
                            self.handlers.onError(error);
                        }
                        throw error;
                    });
                }
                return response.text().then(function (text) {
                    var contentType = response.headers.get('Content-Type') || '';
                    var isJson = contentType.indexOf('application/json') !== -1;
                    var parsed = null;

                    if (isJson && text !== '') {
                        try {
                            parsed = JSON.parse(text);
                        } catch (e) {
                            // ignore
                        }
                    }

                    if (response.status === 204) {
                        return {};
                    }

                    if (response.ok) {
                        if (isJson) {
                            return parsed || {};
                        }
                        return text ? { raw: text } : {};
                    }

                    var payload =
                        isJson && parsed && typeof parsed === 'object' ? parsed : null;
                    var errorCode =
                        (payload && (payload.errorCode || payload.error)) || null;

                    var error = new HeliontApiError(
                        payloadFailureMessage(payload, 'HTTP ' + response.status + ' for ' + url),
                        {
                            status: response.status,
                            errorCode: errorCode,
                            errorType: (payload && payload.errorType) || null,
                            nextAction:
                                payload && payload.nextAction != null
                                    ? payload.nextAction
                                    : null,
                            details: (payload && payload.details) || null,
                            links: (payload && payload.links) || null,
                            payload: payload,
                            url: url,
                            requiredTrustLevel:
                                (payload && payload.requiredTrustLevel) || null,
                            request: replayableRequest
                        }
                    );

                    if (error.isAuthenticationRequired()) {
                        self.handlers.onAuthenticationRequired(error);
                    } else if (error.isTrustLevelStepUpRequired()) {
                        // Handled by request() wrapper.
                    } else if (error.isPermissionDenied()) {
                        self.handlers.onPermissionDenied(error);
                    } else {
                        self.handlers.onError(error);
                    }

                    throw error;
                });
            })
            .catch(function (err) {
                if (err instanceof HeliontApiError) {
                    throw err;
                }

                var wrapped = new HeliontApiError(
                    'Network error while calling ' + url,
                    { status: null, url: url }
                );

                self.handlers.onError(wrapped);
                throw wrapped;
            });
    };

    ApiService.prototype.buildReplayableRequest = function (endpoint, method, body) {
        if (
            body instanceof FormData ||
            body instanceof Blob ||
            body instanceof ArrayBuffer ||
            (body && typeof body === 'object' && typeof body.pipe === 'function')
        ) {
            return null;
        }

        var replay = {
            endpoint: endpoint,
            method: method
        };

        if (body == null) {
            return replay;
        }

        if (typeof body === 'string') {
            replay.body = body;
            replay.bodyType = 'string';
        } else if (typeof body === 'object') {
            try {
                JSON.stringify(body);
                replay.body = body;
                replay.bodyType = 'json';
            } catch (e) {
                // skip body
            }
        }

        return replay;
    };

    ApiService.prototype.buildUrl = function (endpoint, query) {
        var clean = endpoint || '';
        if (!clean.startsWith('/')) {
            clean = '/' + clean;
        }

        var url = new URL(clean, window.location.origin);

        if (query && typeof query === 'object') {
            Object.keys(query).forEach(function (key) {
                var value = query[key];
                if (value === null || value === undefined) {
                    return;
                }
                url.searchParams.append(key, String(value));
            });
        }

        return url.toString();
    };

    ApiService.prototype.generateCorrelationId = function () {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            return crypto.randomUUID();
        }

        return 'cid-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    };

    ApiService.prototype.unwrapResponse = function (response) {
        if (response && typeof response === 'object' && Object.prototype.hasOwnProperty.call(response, 'data')) {
            return response.data;
        }

        return response;
    };

    ApiService.prototype.getJson = function (endpoint, query, options) {
        options = options || {};

        return this.request(endpoint, {
            method: 'GET',
            query: query,
            headers: options.headers,
            credentials: options.credentials,
        }).then(this.unwrapResponse.bind(this));
    };

    ApiService.prototype.requestBlob = function (endpoint, options) {
        options = options || {};
        return this.request(endpoint, {
            method: options.method || 'GET',
            query: options.query,
            headers: options.headers,
            credentials: options.credentials,
            responseType: 'blob',
        });
    };

    ApiService.prototype.postJson = function (endpoint, body, options) {
        options = options || {};

        return this.request(endpoint, {
            method: 'POST',
            body: body,
            headers: options.headers,
            credentials: options.credentials,
        }).then(this.unwrapResponse.bind(this));
    };

    function requireHeliontApi() {
        var api = window.Heliont && window.Heliont.api;

        if (!api || typeof api.request !== 'function') {
            throw new HeliontApiError(
                'Heliont API client is not initialized. API requests cannot run.',
                {
                    status: null,
                    errorCode: 'api_client_unavailable',
                }
            );
        }

        return api;
    }

    ApiService.prototype.buildStepUpUrl = function (error) {
        var stepUpUrl =
            (error && error.links && error.links.step_up) ||
            '/iam/assurance';
        var url = new URL(stepUpUrl, window.location.origin);

        if (!url.searchParams.has('return_to')) {
            url.searchParams.set('return_to', currentStepUpReturnTo());
        }

        return url.toString();
    };

    ApiService.prototype.resolveTrustLevelStepUp = function (error) {
        if (this.useLegacyStepUpNavigation) {
            this.handlers.onTrustLevelStepUpRequired(error);
            return Promise.reject(error);
        }

        if (!this.stepUpInterrupt) {
            this.stepUpInterrupt = new StepUpInterrupt(this);
            window.Heliont.trust = window.Heliont.trust || {};
            window.Heliont.trust.stepUpInterrupt = this.stepUpInterrupt;
        }

        return this.stepUpInterrupt.open(error);
    };

    function defaultStepUpHandler(error) {
        window.location.href = this.buildStepUpUrl(error);
    }

    function defaultPermissionHandler(error) {
        if (window.console && console.warn) {
            console.warn('Permission denied', error);
        }
    }

    function defaultErrorHandler(error) {
        try {
            window.dispatchEvent(new CustomEvent('heliont:api-request-failed', {
                detail: { error: error },
            }));
        } catch (dispatchError) {
            // ignore
        }
    }

    var apiInstance = new ApiService();
    window.Heliont.Core.Services.ApiService = ApiService;
    window.Heliont.Core.Services.HeliontApiError = HeliontApiError;

    if (!window.Heliont.api) {
        window.Heliont.api = apiInstance;
    }

    if (!window.api) {
        window.api = window.Heliont.api;
    }

    window.Heliont.requireApi = requireHeliontApi;
})();// Heliont/Ui/Core/Services/RealtimeService/RealtimeService.js
(function (w) {
  w.Heliont = w.Heliont || {};
  w.Heliont.Core = w.Heliont.Core || {};
  w.Heliont.Core.Services = w.Heliont.Core.Services || {};

  class RealtimeService {
    constructor(config = {}) {
      this.url = config.wsUrl;
      this.token = String(config.token || '');
      this.maxChannels = config.maxChannels;
      this.socket = null;
      this.channels = new Map(); // channel => { handlers:Set<fn>, lastUsed:number }
      this.reconnectTimer = null;
      this.tokenRefreshTimer = null;
      this.isConnecting = false;
      this.isRefreshingToken = false;
      this.ignoreNextCloseEvent = false;
      this.scheduleTokenRefresh();
    }

    connect() {
      if (this.socket && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
        return;
      }
      if (this.isConnecting) {
        return;
      }
      this.isConnecting = true;
      const targetUrl = this.buildSocketUrl();
      this.socket = new WebSocket(targetUrl);
      this.socket.addEventListener('open', () => {
        this.isConnecting = false;
        this.scheduleTokenRefresh();
        this.flushSubscriptions();
      });
      this.socket.addEventListener('message', (event) => this.handleMessage(event));
      this.socket.addEventListener('close', (event) => {
        this.isConnecting = false;
        if (this.ignoreNextCloseEvent) {
          this.ignoreNextCloseEvent = false;
          this.socket = null;
          return;
        }
        this.socket = null;
        if (event.code === 1008) {
          void this.refreshToken();
          return;
        }
        this.scheduleReconnect();
      });
      this.socket.addEventListener('error', () => {
        this.isConnecting = false;
      });
    }

    buildSocketUrl() {
      const baseUrl = String(this.url || '').trim();
      if (!baseUrl || !this.token) return baseUrl;
      try {
        const parsed = new URL(baseUrl, window.location.origin);
        parsed.searchParams.set('token', this.token);
        return parsed.toString();
      } catch {
        const separator = baseUrl.includes('?') ? '&' : '?';
        return `${baseUrl}${separator}token=${encodeURIComponent(this.token)}`;
      }
    }

    scheduleReconnect() {
      if (this.reconnectTimer) {
        return;
      }
      this.reconnectTimer = window.setTimeout(() => {
        this.reconnectTimer = null;
        this.connect();
      }, 2000);
    }

    decodeTokenExp(token) {
      const raw = String(token || '').trim();
      if (!raw.includes('.')) return null;
      const payloadPart = raw.split('.', 2)[0];
      try {
        const normalized = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
        const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);
        const decoded = JSON.parse(atob(padded));
        const exp = Number(decoded?.exp || 0);
        return Number.isFinite(exp) ? exp : null;
      } catch {
        return null;
      }
    }

    scheduleTokenRefresh() {
      if (this.tokenRefreshTimer) {
        window.clearTimeout(this.tokenRefreshTimer);
        this.tokenRefreshTimer = null;
      }
      const exp = this.decodeTokenExp(this.token);
      if (!exp) return;
      const nowSeconds = Math.floor(Date.now() / 1000);
      const lifetimeSeconds = exp - nowSeconds;
      if (lifetimeSeconds <= 0) {
        void this.refreshToken();
        return;
      }
      const refreshInMs = Math.max(1000, Math.floor(lifetimeSeconds * 0.8 * 1000));
      this.tokenRefreshTimer = window.setTimeout(() => {
        this.tokenRefreshTimer = null;
        void this.refreshToken();
      }, refreshInMs);
    }

    async refreshToken() {
      if (this.isRefreshingToken) {
        return;
      }
      this.isRefreshingToken = true;
      try {
        const response = await fetch('/realtime/token', {
          method: 'GET',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        const json = await response.json().catch(() => null);
        const nextToken = String(json?.data?.token || '').trim();
        if (!response.ok || !json?.success || !nextToken) {
          return;
        }
        this.token = nextToken;
        this.scheduleTokenRefresh();
        if (this.socket && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
          this.ignoreNextCloseEvent = true;
          this.socket.close(1000, 'Token refresh');
          this.socket = null;
        }
        this.connect();
      } catch {
        // Token refresh must not break page runtime.
      } finally {
        this.isRefreshingToken = false;
      }
    }

    subscribe(channel, handler) {
      const key = String(channel || '').trim();
      if (!key || typeof handler !== 'function') {
        return () => {};
      }

      if (!this.channels.has(key)) {
        this.ensureCapacityForNewChannel();
        this.channels.set(key, { handlers: new Set(), lastUsed: Date.now() });
      }

      const entry = this.channels.get(key);
      entry.handlers.add(handler);
      entry.lastUsed = Date.now();
      this.connect();
      this.flushSubscriptions();

      return () => this.unsubscribe(key, handler);
    }

    unsubscribe(channel, handler = null) {
      const key = String(channel || '').trim();
      if (!key || !this.channels.has(key)) {
        return;
      }

      const entry = this.channels.get(key);
      if (handler && typeof handler === 'function') {
        entry.handlers.delete(handler);
      } else {
        entry.handlers.clear();
      }

      if (entry.handlers.size === 0) {
        this.channels.delete(key);
      } else {
        entry.lastUsed = Date.now();
      }

      this.flushSubscriptions();
    }

    ensureCapacityForNewChannel() {
      if (this.channels.size < this.maxChannels) return;

      let oldestChannel = null;
      let oldestTime = Number.POSITIVE_INFINITY;
      for (const [channel, entry] of this.channels.entries()) {
        if (entry.lastUsed < oldestTime) {
          oldestTime = entry.lastUsed;
          oldestChannel = channel;
        }
      }

      if (oldestChannel !== null) {
        this.channels.delete(oldestChannel);
      }
    }

    flushSubscriptions() {
      if (!(this.socket instanceof WebSocket) || this.socket.readyState !== WebSocket.OPEN) {
        return;
      }
      const channels = Array.from(this.channels.keys());
      this.socket.send(JSON.stringify({
        type: 'subscribe',
        channels,
      }));
    }

    send(payload) {
      if (!(this.socket instanceof WebSocket) || this.socket.readyState !== WebSocket.OPEN) {
        return false;
      }
      try {
        this.socket.send(JSON.stringify(payload));
        return true;
      } catch {
        return false;
      }
    }

    handleMessage(event) {
      let payload = null;
      try {
        payload = JSON.parse(String(event.data || ''));
      } catch {
        return;
      }
      if (!payload || payload.type !== 'event') {
        return;
      }

      const channel = String(payload.channel || '').trim();
      if (!channel || !this.channels.has(channel)) {
        return;
      }

      const entry = this.channels.get(channel);
      entry.lastUsed = Date.now();
      for (const handler of entry.handlers.values()) {
        try {
          handler(payload.data, payload);
        } catch {
          // Handler failures must not break the socket loop.
        }
      }
    }
  }

  w.Heliont.Core.Services.RealtimeService = RealtimeService;
})(window);


(function (w) {
  w.Heliont = w.Heliont || {};
  w.Heliont.Core = w.Heliont.Core || {};
  w.Heliont.Core.Services = w.Heliont.Core.Services || {};

  /**
   * Regional number/date formatters. Storage stays canonical (dot decimal, ISO UTC).
   */
  w.Heliont.regional = (function () {
    function selectedFormatLocale() {
      const country = selectedRegion();
      try {
        if (typeof Intl !== 'undefined' && typeof Intl.Locale === 'function') {
          const maximized = new Intl.Locale('und-' + country).maximize();
          const language = String(maximized.language ?? '').trim();
          const region = String(maximized.region ?? '').trim().toUpperCase();
          if (language !== '' && /^[A-Z]{2}$/.test(region)) {
            return `${language}_${region}`;
          }
        }
      } catch {
        // fall through
      }
      const fromBootstrap = String(w.__HELIONT__?.selectedFormatLocale ?? '').trim();
      if (fromBootstrap !== '') {
        return fromBootstrap.replace(/-/g, '_');
      }
      return 'en_US';
    }

    function selectedRegion() {
      const raw = String(w.__HELIONT__?.selectedRegion ?? 'US').trim().toUpperCase();
      return /^[A-Z]{2}$/.test(raw) ? raw : 'US';
    }

    function selectedTimeZone() {
      const raw = String(w.__HELIONT__?.selectedTimeZone ?? '').trim();
      if (raw !== '') {
        return raw;
      }
      try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
      } catch {
        return 'UTC';
      }
    }

    function selectedLanguage() {
      const raw = String(w.__HELIONT__?.selectedLanguage ?? w.__HELIONT__?.locale ?? '').trim().replace(/-/g, '_');
      if (/^[a-z]{2}_[A-Z]{2}$/.test(raw)) {
        return raw;
      }
      return 'en_US';
    }

    function toBcp47(heliontLocale) {
      return String(heliontLocale || 'en_US').replace(/_/g, '-');
    }

    function formatDecimal(value, options = {}) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      const numeric = typeof value === 'number' ? value : Number(String(value).replace(',', '.'));
      if (!Number.isFinite(numeric)) {
        return String(value);
      }
      const decimalPlaces = options.decimalPlaces;
      const opts = {};
      if (Number.isInteger(decimalPlaces) && decimalPlaces >= 0) {
        opts.minimumFractionDigits = decimalPlaces;
        opts.maximumFractionDigits = decimalPlaces;
      }
      try {
        return new Intl.NumberFormat(toBcp47(selectedFormatLocale()), opts).format(numeric);
      } catch {
        return String(numeric);
      }
    }

    function parseDecimal(display, options = {}) {
      const text = String(display ?? '').trim();
      if (text === '') {
        return '';
      }
      let normalized = text.replace(/\s|\u00a0|\u202f/g, '');
      const hasComma = normalized.includes(',');
      const hasDot = normalized.includes('.');
      if (hasComma && hasDot) {
        if (normalized.lastIndexOf(',') > normalized.lastIndexOf('.')) {
          // 1.234,56 → 1234.56
          normalized = normalized.replace(/\./g, '').replace(',', '.');
        } else {
          // 1,234.56 → 1234.56
          normalized = normalized.replace(/,/g, '');
        }
      } else if (hasComma) {
        // 0,25 or 1234,56
        normalized = normalized.replace(/,/g, '.');
      }
      // Apostrophe / narrow grouping leftovers (e.g. Swiss)
      normalized = normalized.replace(/'/g, '');
      const numeric = Number(normalized);
      if (!Number.isFinite(numeric)) {
        return text;
      }
      const decimalPlaces = options.decimalPlaces;
      if (Number.isInteger(decimalPlaces) && decimalPlaces >= 0) {
        return numeric.toFixed(decimalPlaces);
      }
      const asFixed = numeric.toFixed(10).replace(/\.?0+$/, '');
      return asFixed === '-0' ? '0' : asFixed;
    }

    /**
     * Keep page bootstrap in sync after regional settings save (no full reload).
     * @param {{ region?: string, timeZone?: string, language?: string }} prefs
     */
    function applyBootstrapPreferences(prefs = {}) {
      w.__HELIONT__ = w.__HELIONT__ || {};
      if (typeof prefs.region === 'string' && prefs.region.trim() !== '') {
        const region = prefs.region.trim().toUpperCase();
        if (/^[A-Z]{2}$/.test(region)) {
          w.__HELIONT__.selectedRegion = region;
        }
      }
      if (typeof prefs.timeZone === 'string' && prefs.timeZone.trim() !== '') {
        w.__HELIONT__.selectedTimeZone = prefs.timeZone.trim();
      }
      if (typeof prefs.language === 'string' && prefs.language.trim() !== '') {
        w.__HELIONT__.selectedLanguage = prefs.language.trim().replace(/-/g, '_');
      }
      w.__HELIONT__.selectedFormatLocale = selectedFormatLocale();
    }

    function formatPaddedParts(date, locale, opts) {
      const parts = new Intl.DateTimeFormat(locale, opts).formatToParts(date);
      return parts.map((part) => {
        if (!/^\d+$/.test(part.value)) {
          return part.value;
        }
        if (part.type === 'year') {
          return part.value.padStart(4, '0');
        }
        if (['month', 'day', 'hour', 'minute', 'second'].includes(part.type)) {
          return part.value.padStart(2, '0');
        }
        return part.value;
      }).join('');
    }

    function formatInstant(iso, style = 'datetime') {
      if (iso === null || iso === undefined || iso === '') {
        return '—';
      }
      const raw = typeof iso === 'string' ? iso.trim() : iso;
      const calendar = typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}/.test(raw)
        ? raw.slice(0, 10)
        : '';
      const dateOnly = style === 'date' || (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(raw));
      const date = dateOnly && calendar !== ''
        ? new Date(`${calendar}T00:00:00Z`)
        : new Date(iso);
      if (Number.isNaN(date.getTime())) {
        return String(iso);
      }
      const opts = dateOnly
        ? { timeZone: 'UTC' }
        : { timeZone: selectedTimeZone() };
      if (style === 'date' || dateOnly) {
        opts.year = 'numeric';
        opts.month = '2-digit';
        opts.day = '2-digit';
      } else if (style === 'time') {
        opts.hour = '2-digit';
        opts.minute = '2-digit';
        opts.second = '2-digit';
      } else {
        opts.year = 'numeric';
        opts.month = '2-digit';
        opts.day = '2-digit';
        opts.hour = '2-digit';
        opts.minute = '2-digit';
        opts.second = '2-digit';
      }
      try {
        return formatPaddedParts(date, toBcp47(selectedFormatLocale()), opts);
      } catch {
        return dateOnly ? raw : date.toISOString();
      }
    }

    function coerceBoolean(value, fieldType) {
      const type = String(fieldType ?? '').trim().toLowerCase();
      const typed = type === 'bool' || type === 'boolean';
      if (!typed && typeof value !== 'boolean') {
        return null;
      }
      if (typeof value === 'boolean') {
        return value;
      }
      if (value === 1 || value === '1' || value === 'true') {
        return true;
      }
      if (value === 0 || value === '0' || value === 'false') {
        return false;
      }
      return null;
    }

    function formatBoolean(value, fieldType = '') {
      const boolean = coerceBoolean(value, fieldType);
      if (boolean === null) {
        return '';
      }
      const key = boolean ? 'boolean_yes' : 'boolean_no';
      const fallback = boolean ? 'Yes' : 'No';
      const translate = w.Heliont?.translation?.t ?? w.t;
      if (typeof translate !== 'function') {
        return fallback;
      }
      const word = String(translate(`user_interface.custom.management.controls.${key}`) ?? '').trim();
      if (word === '' || word.includes(key) || word.includes('translation_error')) {
        return fallback;
      }
      return word;
    }

    function toIsoUtc(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) {
        return String(value);
      }
      return date.toISOString();
    }

    return {
      selectedRegion,
      selectedFormatLocale,
      selectedLanguage,
      selectedTimeZone,
      toBcp47,
      formatDecimal,
      parseDecimal,
      applyBootstrapPreferences,
      formatInstant,
      formatBoolean,
      formatDateTime: (iso) => formatInstant(iso, 'datetime'),
      formatDate: (iso) => formatInstant(iso, 'date'),
      formatRelative: (iso) => {
        const date = iso instanceof Date ? iso : new Date(iso);
        if (Number.isNaN(date.getTime())) {
          return '';
        }
        const diffSec = Math.round((date.getTime() - Date.now()) / 1000);
        const abs = Math.abs(diffSec);
        let value = diffSec;
        let unit = 'second';
        if (abs >= 60) {
          value = Math.round(diffSec / 60);
          unit = 'minute';
        }
        if (abs >= 3600) {
          value = Math.round(diffSec / 3600);
          unit = 'hour';
        }
        if (abs >= 86400) {
          value = Math.round(diffSec / 86400);
          unit = 'day';
        }
        if (abs >= 86400 * 30) {
          value = Math.round(diffSec / (86400 * 30));
          unit = 'month';
        }
        if (abs >= 86400 * 365) {
          value = Math.round(diffSec / (86400 * 365));
          unit = 'year';
        }
        try {
          return new Intl.RelativeTimeFormat(toBcp47(selectedLanguage()), { numeric: 'auto' })
            .format(value, unit);
        } catch {
          return '';
        }
      },
      toIsoUtc,
    };
  }());

  /**
   * Format an ISO-8601 instant using the person's region and time zone.
   */
  w.Heliont.formatInstant = function (iso) {
    return w.Heliont.regional.formatInstant(iso, 'datetime');
  };

  if (w.Heliont.Core.Services.TranslationService && !w.Heliont.translation) {
    w.Heliont.translation = new w.Heliont.Core.Services.TranslationService(null);
  }

  if (w.Heliont.translation && !w.Heliont.i18n) {
    w.Heliont.i18n = w.Heliont.translation;
  }

  if (!w.t && w.Heliont.translation) {
    w.t = function (key, placeholders) {
      return w.Heliont.translation.t(key, placeholders);
    };
  }

  if (w.Heliont.Core.Services.ApiService && !w.Heliont.api) {
    w.Heliont.api = new w.Heliont.Core.Services.ApiService();
  }

  if (!w.api && w.Heliont.api) {
    w.api = w.Heliont.api;
  }

  if (w.Heliont.Core.Services.RealtimeService && w.__HELIONT_REALTIME_CONFIG__ && !w.realtime) {
    w.realtime = new w.Heliont.Core.Services.RealtimeService(w.__HELIONT_REALTIME_CONFIG__);
    if (typeof w.realtime.connect === 'function') {
      w.realtime.connect();
    }
  }

  /** @type {Map<string, { open: Function, close?: Function }>} */
  if (!w.Heliont.fieldEditors?.register || !w.Heliont.fieldEditors?.get) {
    const fieldEditorRegistry = new Map();

    w.Heliont.fieldEditors = {
      /**
       * @param {string} unitCode
       * @param {{ open: Function, close?: Function }} api
       */
      register(unitCode, api) {
        const code = String(unitCode ?? '').trim();

        if (code === '' || typeof api?.open !== 'function') {
          return;
        }

        fieldEditorRegistry.set(code, api);
      },

      /**
       * @param {string} unitCode
       * @returns {{ open: Function, close?: Function }|null}
       */
      get(unitCode) {
        const code = String(unitCode ?? '').trim();

        return code === '' ? null : (fieldEditorRegistry.get(code) ?? null);
      },
    };
  }
})(window);
